export const cn = (...i) => i.filter(Boolean).join(' ');
export const debounce = (f) => f;
export const throttle = (f) => f;
export const sleep = (ms) => new Promise(r => setTimeout(r, ms));
export default {};